<template>
	<div class="countryAndBudgetVal">
		<el-row :gutter="40">
			<el-col :span="12">
				<div class="col">
					<div class="col-box">
						<span class="text">已排除：</span>
						<div class="valueDiv">{{ removeRegion }}</div>
					</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="col">
					<div class="col-box">
						<span class="text">重点添加：</span>
						<div class="valueDiv">{{ importantRegion || '无' }}</div>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col>
				<div class="col">
					<div class="col-box">
						<span class="text">账户日预算：</span>
						<div class="valueDiv">{{ budgetVal }}</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default {
	props: ['importantRegionList', 'removeRegionList', 'budgetVal'],
	data() {
		return {};
	},

	components: {},

	computed: {
		removeRegion() {
			// 取消俄罗斯注释
			// let defaultList = [
			// 	{ regionId: '2736', regionName: '苏丹' },
			// 	{ regionId: '2643', regionName: '俄罗斯' },
			// ];
			let defaultList = [{ regionId: '2736', regionName: '苏丹' }];
			let arr = [];
			if (this.removeRegionList && this.removeRegionList.length) {
				// 取消俄罗斯注释
				// let v = this.removeRegionList.filter(
				// 	item => item.regionName !== '苏丹' && item.regionName !== '俄罗斯'
				// );
				let v = this.removeRegionList.filter(item => item.regionName !== '苏丹');
				arr = v.concat(defaultList).map(e => {
					return e.regionName;
				});
			}

			return arr.length ? arr.toString() : '';
		},
		importantRegion() {
			let arr = [];
			if (this.importantRegionList && this.importantRegionList.length) {
				arr = this.importantRegionList.map(e => {
					return e.regionName;
				});
			}
			return arr.length ? arr.toString() : '';
		},
	},

	methods: {},
};
</script>

<style lang="scss" scoped>
.countryAndBudgetVal {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #333333;
	padding: 20px 40px;
	.col {
		height: auto;
		margin-bottom: 20px;
	}

	.col-box {
		display: flex;
		.text {
			width: 100px;
			text-align: right;
			line-height: 20px;
		}
		.valueDiv {
			flex: 1;
			line-height: 20px;
			word-spacing: 1px;
			letter-spacing: 1px;
		}
	}
}
</style>
